const testimonials = [
  {
    id: 1,
    quote: 'Being part of Youth United transformed my perspective on leadership. The real-world impact we create is far more rewarding than any textbook could offer.',
    author: 'Riya Kapoor',
    role: 'Alumni, CSE 2024 · Now at Google',
    initials: 'RK',
    stars: 5,
  },
  {
    id: 2,
    quote: 'Youth United gave me my first leadership role at 19. Managing a team, handling logistics, and seeing the smiles of the children we teach — it is irreplaceable.',
    author: 'Samarth Verma',
    role: 'Core Member, ME 3rd Year',
    initials: 'SV',
    stars: 5,
  },
  {
    id: 3,
    quote: 'The network I built through Youth United opened doors I never imagined. Every recruiter I met was impressed by the scale of work we do here.',
    author: 'Divya Nambiar',
    role: 'Alumni, ECE 2023 · Now at McKinsey',
    initials: 'DN',
    stars: 5,
  },
];

export default testimonials;
